module.exports = __webpack_public_path__ + "img/9788960178410.77483835.jpg";